'use client';

import { createClient } from '@/lib/supabase/client';

export interface SMSNotification {
  to: string;
  message: string;
}

export const smsService = {
  async sendSMS(notification: SMSNotification) {
    try {
      const supabase = createClient();
      const functionUrl = process.env.NEXT_PUBLIC_SUPABASE_FUNCTION_URL;

      if (!functionUrl) {
        throw new Error('Supabase function URL not configured');
      }

      const { data: { session } } = await supabase.auth.getSession();

      const response = await fetch(`${functionUrl}/send-sms`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${session?.access_token || ''}`
        },
        body: JSON.stringify(notification)
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to send SMS');
      }

      return await response.json();
    } catch (error: any) {
      console.error('SMS Service Error:', error);
      throw error;
    }
  },

  async sendBookingConfirmation(customerPhone: string, orderNumber: string, serviceName: string, pickupDate: string, pickupTime: string) {
    let message = `WashConnect Gambia: Booking confirmed! Order #${orderNumber} for ${serviceName}. Pickup: ${pickupDate} at ${pickupTime}. Thank you!`;
    return this.sendSMS({ to: customerPhone, message });
  },

  async sendPickupReminder(customerPhone: string, orderNumber: string, pickupTime: string) {
    let message = `WashConnect Gambia: Reminder! Your laundry pickup (Order #${orderNumber}) is scheduled in 30 minutes at ${pickupTime}. We'll be there soon!`;
    return this.sendSMS({ to: customerPhone, message });
  },

  async sendServiceCompletion(customerPhone: string, orderNumber: string, status: string) {
    let message = '';
    if (status === 'ready') {
      message = `WashConnect Gambia: Great news! Your laundry (Order #${orderNumber}) is ready for pickup. Visit us anytime!`;
    } else if (status === 'completed') {
      message = `WashConnect Gambia: Order #${orderNumber} completed! Thank you for choosing us. We hope to serve you again soon!`;
    }
    return this.sendSMS({ to: customerPhone, message });
  }
};